import { compactInsightDates } from './insight-dates';
import type { EvidenceFact } from '@lognai/plugin-analytics';

export const formatEvidenceValue = (fact: EvidenceFact): string => {
  const value = typeof fact.value === 'string' && fact.unit && /^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(fact.value.trim())
    ? Number(fact.value) : fact.value;
  if (typeof value !== 'number') return compactInsightDates(value);
  if (!Number.isFinite(value)) return '—';
  if (fact.unit === 'currency') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: fact.currency ?? 'USD', notation: 'compact', maximumFractionDigits: 1,
    }).format(value);
  }
  if (fact.unit === 'percent') return `${(value * 100).toFixed(1)}%`;
  if (fact.unit === 'days') return `${value.toFixed(1)} days`;
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
};
